
        <span #rippleCover class="btn-ripple-cover"
            *ngIf="_btnEffect==='ripple'"></span>
        <i class="iconfont icon-jui-loading icon-doTurn"
            *ngIf="_btnLoading"></i>
        <ng-content></ng-content>
    